import { Injectable } from '@angular/core';
import { EnvService, HttpWrapperService } from '.';
import { Observable } from 'rxjs';
import { IHttpResponse, PatientAddressFormValues } from '../models';

@Injectable({ providedIn: 'root' })
export class AddressVerificationService {
  constructor(private envService: EnvService, private httpClient: HttpWrapperService) {}

  verifyPatientAddress(address: PatientAddressFormValues): Observable<IHttpResponse<any>> {
    let zip5: string = '';
    let zip4: string = '';

    if (address.zipCode!.length > 5) {
      zip5 = address.zipCode!.substring(0, 5);
      zip4 = address.zipCode!.substring(6, 10);
    }

    const addressXml = encodeURIComponent(
      `<AddressValidateRequest USERID="${this.envService.addressVerification.userId}">` +
        `<Revision>1</Revision>` +
        `<Address ID="0">` +
        `<Address1>${address.line1}</Address1>` +
        `<Address2>${address.line2 || ''}</Address2>` +
        `<City>${address.city}</City>` +
        `<State>${address.state}</State>` +
        `<Zip5>${zip5 || ''}</Zip5>` +
        `<Zip4>${zip4 || ''}</Zip4>` +
        `</Address>` +
        `</AddressValidateRequest>`
    );

    const url = this.envService.addressVerification.apiBaseUrl + '?API=Verify&XML=' + addressXml;

    return this.httpClient.get<IHttpResponse<any>>(url, { responseType: 'text' });
  }
}
